import { asyncActionType } from 'util/methods';

export const SUPPLIER_MANAGER_INIT = "SUPPLIER_MANAGER_INIT";
export const SUPPLIER_LIST_TAB_CHANGE = "SUPPLIER_LIST_TAB_CHANGE";
export const NEW_FILTER_ADD = "NEW_FILTER_ADD";
export const FILTER_REMOVE = "FILTER_REMOVE";
export const FILTERS_CLEAR = "FILTERS_CLEAR";
export const SELECT_SUPPLIER = "SELECT_SUPPLIER";
export const SELECT_ALL_SUPPLIERS = "SELECT_ALL_SUPPLIERS";
export const SELECTED_SUPPLIERS_RESET = "SELECTED_SUPPLIERS_RESET";
export const SUPPLIER_MANAGER_RESET = "SUPPLIER_MANAGER_RESET";

//
//  ******* Tag Dialog Related *******
//

export const SUPPLIER_MANAGER_ADD_TAGS_DIALOG_INIT = "SUPPLIER_MANAGER_ADD_TAGS_DIALOG_INIT";

//
//  ******* Supplier Favorite Toggle  *******
//

export const SUPPLIER_FAVORITE_TOGGLE_BEGIN = "SUPPLIER_FAVORITE_TOGGLE_BEGIN";
export const SUPPLIER_FAVORITE_TOGGLE_SUCCESS = "SUPPLIER_FAVORITE_TOGGLE_SUCCESS";
export const SUPPLIER_FAVORITE_TOGGLE_FAIL = "SUPPLIER_FAVORITE_TOGGLE_FAIL";

//
//  ******* Supplier Classification  *******
//

export const SUPPLIER_CLASSIFICATION_CHANGE_BEGIN = "SUPPLIER_CLASSIFICATION_CHANGE_BEGIN";
export const SUPPLIER_CLASSIFICATION_CHANGE_SUCCESS = "SUPPLIER_CLASSIFICATION_CHANGE_SUCCESS";
export const SUPPLIER_CLASSIFICATION_CHANGE_FAIL = "SUPPLIER_CLASSIFICATION_CHANGE_FAIL";

//
//  ******* Suppliers Bulk Classification  *******
//

export const SUPPLIERS_CLASSIFICATION_CHANGE_BEGIN = "SUPPLIERS_CLASSIFICATION_CHANGE_BEGIN";
export const SUPPLIERS_CLASSIFICATION_CHANGE_SUCCESS = "SUPPLIERS_CLASSIFICATION_CHANGE_SUCCESS";
export const SUPPLIERS_CLASSIFICATION_CHANGE_FAIL = "SUPPLIERS_CLASSIFICATION_CHANGE_FAIL";

//
//  ******* Export Supplier Summary *******
//
export const SUPPLIER_EXPORT_SUMMARY_BEGIN = "SUPPLIER_EXPORT_SUMMARY_BEGIN";
export const SUPPLIER_EXPORT_SUMMARY_SUCCESS = "SUPPLIER_EXPORT_SUMMARY_SUCCESS";
export const SUPPLIER_EXPORT_SUMMARY_FAIL = "SUPPLIER_EXPORT_SUMMARY_FAIL";

//
//  ******* Supplier Assign Tags  *******
//

export const SUPPLIERS_HANDLE_TAGS_BEGIN = "SUPPLIERS_HANDLE_TAGS_BEGIN";
export const SUPPLIERS_HANDLE_TAGS_SUCCESS = "SUPPLIERS_HANDLE_TAGS_SUCCESS";
export const SUPPLIERS_HANDLE_TAGS_FAIL = "SUPPLIERS_HANDLE_TAGS_FAIL";

//
//  ******* Send Mass Message *******
//

export const SUPPLIER_MESSAGE_SEND_BEGIN = "SUPPLIER_MESSAGE_SEND_BEGIN";
export const SUPPLIER_MESSAGE_SEND_SUCCESS = "SUPPLIER_MESSAGE_SEND_SUCCESS";
export const SUPPLIER_MESSAGE_SEND_FAIL = "SUPPLIER_MESSAGE_SEND_FAIL";
export const SUPPLIER_MESSAGE_SEND_RESET = "SUPPLIER_MESSAGE_SEND_RESET";

export const SupplierTypes = {
  UPDATE_SUPPLIERS: asyncActionType('UPDATE_SUPPLIERS'),
}
